import { useEffect, useMemo, useState } from 'react';
const channelInstances: { [key: string]: BroadcastChannel } = {};

const getSingletonChannel = (name: string): BroadcastChannel => {
    if (!channelInstances[name]) {
        channelInstances[name] = new BroadcastChannel(name);
    }
    return channelInstances[name];
};

export default function useBroadcastChannel<T>(channelName: string) {
    const [message, setMessage] = useState<T | null>(null);
    const channel = useMemo(() => getSingletonChannel(channelName), [channelName]);

    useEffect(() => {
        channel.onmessage = (event: any) => {
            setMessage(event.data);
        };
        // Clean up the channel when the component unmounts
        return () => {
            channel.close();
        };
    }, [channel]);

    const sendMessage = (msg: T) => {
        try {
            channel.postMessage(msg);
        } catch (e) {
            console.error(e);
        }
    };

    return { message, sendMessage };
}
